import { makeStyles, Theme } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'container',
    `
		display: flex;
		justify-content: space-between;

		@media (max-width: 720px) {
			flex-direction: column;
		}
	`
  ]
]);

export const itemStyle = (theme: Theme) => `
	display: block;
	line-height: 32px;
	margin: 4px;
	padding: 2px 4px;
	border-radius: 4px;
	border-width: 1px;
	border-style: solid;
	background-color: ${theme.color.text.white};
	outline: 0;
	user-select: none;
	cursor: pointer;
`;
